import React from 'react';
import PageIframe from 'App/components/PageIframe/PageIframe';
import { usePageIframeInit } from 'App/components/PageIframe/usePageIframeInit';
import './OrderPage.scss';

type Props = {
	/** Slug of the agent_page to embed (placement === 'orderModal' or 'projectPlan'). */
	slug: string;
	/** The order being edited — exposed to the page via `useOrder()`. */
	orderId?: number;
	/** The project being edited — exposed to the page via `useProject()` (WEB-13531). */
	projectId?: number;
	/** The record's account, if any — exposed to the page via `useAccount()`. */
	clientId: number | null;
};

/**
 * Embeds a sandboxed Upsales Page (placement: 'orderModal') as a tab inside the
 * order edit modal. Passes the order id (and the order's client id) into the
 * iframe init so the page's `useOrder()` / `useAccount()` hooks resolve to the
 * order being edited (WEB-6999). The project drawer reuses it for 'projectPlan'
 * Pages, passing the project id for `useProject()` instead (WEB-13531).
 */
export default function OrderPage({ slug, orderId, projectId, clientId }: Props) {
	const init = usePageIframeInit(clientId, orderId ?? null, projectId ?? null);

	return (
		<div className="OrderAgentPage">
			<PageIframe slug={slug} init={init} />
		</div>
	);
}
